import React, {FC, memo} from 'react';

import {useNavContext} from '../../NavContextProvider';
import NavBreadcrumbs from './NavBreadcrumbs';

const NavLeftDefaultComp: FC = () => {
  const {params, shouldShowBreadcrumbs} = useNavContext();

  if (params.entityName == null || !shouldShowBreadcrumbs) {
    return null;
  }

  return <NavBreadcrumbs />;
};

const NavLeftDefault = memo(NavLeftDefaultComp);

export default NavLeftDefault;
